import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotebook = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 3.3777V14.3334M7.99967 14.3334C6.04174 13.4434 3.46423 12.7977 1.33301 13.711V3.37769C3.32955 2.23681 5.98308 2.64439 7.99967 3.3777C10.0163 2.64439 12.6698 2.23682 14.6663 3.3777V13.711C12.5351 12.7977 9.95761 13.4434 7.99967 14.3334Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgNotebook);
export default ForwardRef;
